import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

import ChatDots from '@/assets/icons/chat_bubble_outline_dots.svg?react'
import ChatWarning from '@/assets/icons/chat_bubble_outline_warning.svg?react'
import Check from '@/assets/icons/check.svg?react'
import ChevronDown from '@/assets/icons/chevron_down.svg?react'
import Clear from '@/assets/icons/close.svg?react'
import Edit from '@/assets/icons/edit.svg?react'
import Error from '@/assets/icons/error.svg?react'
import Info from '@/assets/icons/info.svg?react'
import Loading from '@/assets/icons/loading.svg?react'
import Phone from '@/assets/icons/phone.svg?react'
import Search from '@/assets/icons/search.svg?react'
import ThumbsUp from '@/assets/icons/thumbs_up.svg?react'
import Warning from '@/assets/icons/warning.svg?react'

export const IconWrapper = (props: SvgIconProps) => (
  <SvgIcon inheritViewBox {...props} />
)

export const ClearIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Clear as React.ElementType} />
)

export const SearchIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Search as React.ElementType} />
)

export const InfoIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Info as React.ElementType} />
)

export const ChatDotsIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={ChatDots as React.ElementType} />
)

export const ChatWarningIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={ChatWarning as React.ElementType} />
)

export const ErrorIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Error as React.ElementType} />
)

export const PhoneIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Phone as React.ElementType} />
)

export const WarningIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Warning as React.ElementType} />
)

export const ThumbsUpIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={ThumbsUp as React.ElementType} />
)

export const LoadingIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Loading as React.ElementType} />
)

export const CheckIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Check as React.ElementType} />
)

export const ChevronDownIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={ChevronDown as React.ElementType} />
)

export const EditIcon = (props: SvgIconProps) => (
  <IconWrapper {...props} component={Edit as React.ElementType} />
)
